module.exports = __webpack_public_path__ + "static/img/valores.756df77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valores.jpg
// module id = wVB1
// module chunks = 1